let env = require("./prod.json");

export const API_URL = env.API_URL;
export const GOOGLE_ANALYTICS = env.GOOGLE_ANALYTICS;
export const TRACKING_ID = env.TRACKING_ID;